import React, { ReactElement, ReactNode } from 'react';

type TitreCarteProps = {
    children: ReactNode;
};

export function TitreCarte(props: TitreCarteProps): ReactElement {
    return (
        <div
            style={{
                padding: '8px 0px 0px 4px',
                fontSize: '1.2em',
            }}
        >
            {props.children}
        </div>
    );
}
